module.exports = __webpack_public_path__ + "static/img/menhu.e5cf7fd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/index/menhu.jpg
// module id = fKZ6
// module chunks = 10